import request from '@/network/network'

// app 下载链接
export async function needUpdate(params) {
    return request({
        url: '/appVersion/needUpdate',
        method: 'get',
        params
    })
}

// 验证用户是否是老用户
export async function verifyPhoneRegister(params) {
    return request({
        url: '/appVersion/verifyPhoneRegister',
        method: 'get',
        params
    })
}
// 关联电销员
export async function associateCallSale(params) {
    return request({
        url: '/appVersion/associateCallSale',
        method: 'post',
        // data,
        params
    })
}
// 下载页点击
export async function landPageClick(landPageId){
    return request({
        url:`/landPage/click/${landPageId}`,
        method:'get',
    })
}
// 下载页信息
export async function landPageDetail(landPageId){
    return request({
        url:`/landPage/detail/${landPageId}`,
        method:'get',
    })
}